import { MetrikaTheme } from '@metrika/ui-kit';
import {
   Header,
   HeaderGlobalAction,
   HeaderGlobalBar,
   HeaderMenuButton,
   InlineLoading,
   Switcher,
   SwitcherItem,
} from '@metrika/ui-kit/carbon';
import { UserAvatar } from '@metrika/ui-kit/icons/carbon';
import React, { useCallback, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { appEnv } from '../../../_env';
import { DebugIcon } from '../../../_shared/debug';
import { cleanSearch } from '../../../_shared/queryString';
import { IconButton, SearchButton } from '../../../search/SearchButton';
import { useIsLogged, useUserState } from '../../../user/hooks';
import OverlayHeaderPanel from './OverlayHeaderPanel';
import { HeaderAvatar, SwitcherItemDisabled, TopLogo } from './styles';

export const HeaderMenu = ({ isExpanded, buttonHandler }: { isExpanded: boolean; buttonHandler: () => void }) => {
   const history = useHistory();
   const [rightSidebarExpanded, setRightSidebarExpanded] = useState(false);

   const handleRightSidebarButtonClick = useCallback(() => {
      setRightSidebarExpanded(!rightSidebarExpanded);
   }, [rightSidebarExpanded, setRightSidebarExpanded]);

   const userEmail = useUserState().data?.email;
   const userAvatarURL = useUserState().data?.avatar;

   const handleLeftSideBarClick = () => {
      buttonHandler();
      if (rightSidebarExpanded) {
         setRightSidebarExpanded(false);
      }
   };

   const { pathname, search } = useLocation();
   /*  const [aboutModalOpen, setAboutModalOpen] = useState(false);*/

   //TODO: investigate
   const safePathname = pathname || window.location.pathname; // pathname randomly is undefined TODO: investigate

   const { userLoading, isLogged } = useIsLogged();

   const loginUrl = `${appEnv.appDomains.login}/login?return_to=${appEnv.appDomains.loginReturnTo + safePathname + cleanSearch(search)}`;
   const logoutUrl = `${appEnv.appDomains.login}/logout?return_to=${appEnv.appDomains.loginReturnTo + safePathname?.replaceAll('/error', '') + cleanSearch(search)}`;
   return (
      <Header
         aria-label="Metrika"
         //onClick={isExpanded ? handleLeftSideBarClick : undefined}
         //  style={{ userSelect: 'none' }}
      >
         {safePathname !== '/' && !safePathname.startsWith('/risk/settings') && (
            <HeaderMenuButton
               aria-label="Open menu"
               // disable this onclick when the left sidebar is expanded
               // so it doesn't cancel out the header onclick, which is enabled when exapnded
               onClick={isExpanded ? undefined : handleLeftSideBarClick}
               isActive={isExpanded}
            />
         )}
         {/*         <MetrikaAboutModal open={aboutModalOpen} onClose={() => setAboutModalOpen(false)} />*/}
         <div style={{ padding: '0' }}>
            <TopLogo src="/logo192.png" alt="Metrika Logo" />
         </div>
         <Link
            style={{
               fontSize: '1.0rem',
               fontWeight: 'bold',
               margin: '0 0.5rem',
               color: 'var(--cds-text-primary)',
               textDecoration: 'none',
            }}
            to="/"
         >
            Metrika
         </Link>
         <IconButton>
            <MetrikaTheme.Button
               style={{
                  position: 'relative',
                  top: 'unset',
                  left: 'unset',
               }}
            />
         </IconButton>
         <DebugIcon />
         {userLoading ? (
            <div style={{ marginLeft: 'auto' }}>
               <InlineLoading />
            </div>
         ) : isLogged ? (
            <>
               <HeaderGlobalBar>
                  <SearchButton />

                  <HeaderGlobalAction
                     aria-label="User Information"
                     tooltipAlignment="end"
                     isActive={rightSidebarExpanded}
                     onClick={handleRightSidebarButtonClick}
                  >
                     {userAvatarURL ? <HeaderAvatar src={userAvatarURL} alt="User Avatar" /> : <UserAvatar size={32} />}
                  </HeaderGlobalAction>
               </HeaderGlobalBar>
            </>
         ) : (
            <a
               style={{
                  fontSize: '1.0rem',
                  fontWeight: 'normal',
                  marginRight: '.5rem',
                  color: 'white',
                  textDecoration: 'none',
                  marginLeft: 'auto',
               }}
               href={loginUrl}
               rel="noopener noreferrer"
            >
               Sign In
            </a>
         )}
         <OverlayHeaderPanel
            aria-label="User Information Panel"
            expanded={rightSidebarExpanded}
            onClick={handleRightSidebarButtonClick}
         >
            <Switcher aria-label="Switcher Container">
               <SwitcherItemDisabled href={'#'} aria-label="user email">
                  {userEmail || ''}
               </SwitcherItemDisabled>
               <SwitcherItem
                  href={'/risk/settings'}
                  aria-label="user settings"
                  onClick={(e) => {
                     e.preventDefault();
                     handleRightSidebarButtonClick();
                     history.push('/risk/settings');
                  }}
               >
                  Settings
               </SwitcherItem>
               <SwitcherItem
                  href={logoutUrl}
                  aria-label="sign out"
                  /*   onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                     e.preventDefault();
                     doLogout();
                  }}
                  aria-disabled={logoutLoading}*/
               >
                  Log out
               </SwitcherItem>
            </Switcher>
         </OverlayHeaderPanel>
      </Header>
   );
};
